import './VSimpleTable.sass'

import { convertToUnit } from '../../util/helpers'
import Themeable from '../../mixins/themeable'
import mixins from '../../util/mixins'
import { VNode } from 'vue'

export default mixins(Themeable).extend({
  name: 'v-simple-table',

  props: {
    dense: Boolean,
    fixedHeader: Boolean,
    height: [Number, String],
    classPrefix: {
      type: String,
      default: '',
    },
  },

  computed: {
    classes (): Record<string, boolean> {
      return {
        [`${this.classPrefix}v-data-table--dense`]: this.dense,
        [`${this.classPrefix}v-data-table--fixed-height`]: !!this.height && !this.fixedHeader,
        [`${this.classPrefix}v-data-table--fixed-header`]: this.fixedHeader,
        [`${this.classPrefix}v-data-table--has-top`]: !!this.$slots.top,
        [`${this.classPrefix}v-data-table--has-bottom`]: !!this.$slots.bottom,
        ...this.themeClasses,
      }
    },
  },

  methods: {
    genWrapper () {
      return this.$slots.wrapper || this.$createElement('div', {
        staticClass: `${this.classPrefix}v-data-table__wrapper`,
        style: {
          height: convertToUnit(this.height),
        },
      }, [
        this.$createElement('table', this.$slots.default),
      ])
    },
  },

  render (h): VNode {
    return h('div', {
      staticClass: `${this.classPrefix}v-data-table`,
      class: this.classes,
    }, [
      this.$slots.top,
      this.genWrapper(),
      this.$slots.bottom,
    ])
  },
})
